<script>
import Layout from "../../layouts/main";

import PageHeader from "@/components/page-header";
import {required} from "vuelidate/lib/validators";
import appConfig from "@/app.config";
import {notifyModel} from "@/models/notifyModel";
import {pagingModel} from "@/models/pagingModel";
import {lichCongTacModel} from "@/models/lichCongTacModel";
import {CONSTANTS} from "@/helpers/constants";
import DatePicker from "vue2-datepicker";
import Multiselect from "vue-multiselect";
import {congViecModel} from "@/models/congViecModel";
import vue2Dropzone from "vue2-dropzone";

export default {
  page: {
    title: "Công việc",
    meta: [{name: "description", content: appConfig.description}],
  },
  components: {Layout, PageHeader, DatePicker, Multiselect, vueDropzone: vue2Dropzone, 'ckeditor-nuxt': () => { return import('@blowstack/ckeditor-nuxt')  },},
  data() {
    return {
      title: "Công việc",
      items: [
        {
          text: "Công việc",
          href: "#",
          // active: true,
        },
        {
          text: "Danh sách",
          active: true,
        }
      ],
      data: [],
      showModal: false,
      showDetail: false,
      showDeleteModal: false,
      showDeleteModalCongViec: false,
      submitted: false,
      model: lichCongTacModel.baseJson(),
      modelCongViec: congViecModel.baseJson(),
      listCoQuan: [],
      listRole: [],
      pagination: pagingModel.baseJson(),
      totalRows: 1,
      todoTotalRows: 1,
      currentPage: 1,
      numberOfElement: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      todoFilter: null,
      filterOn: [],
      isBusy: false,
      sortBy: "age",
      sortDesc: false,
      fields: [
        {key: 'STT', label: 'STT', class: 'text-center', sortable: false, thClass: 'hidden-sortable', thStyle: {width: '50px', minWidth: '50px'},},
        {
          key: "tuNgay",
          label: "Ngày",
          sortable: true,
          thStyle: {width: '100px', minWidth: '100px'},
          class: "text-center"
        },
        {
          key: "thoiGian",
          label: "Thời gian",
          thClass: 'hidden-sortable',
          thStyle: {width: '100px', minWidth: '100px'},
          sortable: false,
          class: "text-center"
        },
        {
          key: 'noiDung',
          label: "Nội dung",
          thClass: 'hidden-sortable',
          sortable: false,
        },
        {
          key: 'diaDiem',
          label: "Địa điểm",
          thClass: 'hidden-sortable',
          thStyle: {width: '200px', minWidth: '200px'},
          sortable: false,
        },
        {
          key: 'thanhPhan',
          label: "Thành phần",
          thClass: 'hidden-sortable',
          sortable: false,
        },
        {
          key: 'ghiChu',
          label: "Ghi chú",
          thClass: 'hidden-sortable',
          thStyle: {width: '200px', minWidth: '100px'},
          sortable: false,
        },
        {
          key: 'process',
          label: 'Xử lý',
          class: 'btn-process text-center',
          thStyle: {width: '100px', minWidth: '100px'},
          thClass: 'hidden-sortable',
          sortable: false
        }
      ],
      optionsUser: [],
      showCongViecModel: false,
      editorConfig: {
        toolbar: {
          items: [
            'heading', '|',
            'fontfamily', 'fontsize', '|',
            'bold', 'italic', 'underline', '|',
            'alignment', '|',
            'undo', 'redo'
          ],
          shouldNotGroupWhenFull: false
        },
        removePlugins: ['Title', 'ImageCaption'],
        simpleUpload: {
          uploadUrl: process.env.VUE_APP_API_URL + "files/upload-ckeditor",
          headers: {
            'Authorization': 'optional_token'
          }
        },
      },
      dropzoneOptions: {
        url: `${process.env.VUE_APP_API_URL}files/upload`,
        thumbnailWidth: 300,
        thumbnailHeight: 160,
        maxFiles: 1,
        maxFilesize: 30,
        headers: {"My-Awesome-Header": "header value"},
        addRemoveLinks: true,
        acceptedFiles: ".pdf, .doc, .docx",
        dropzoneClassName: "dropzonevue-box"
      },
    };
  },
  validations: {
    model: {
      ngayXepLich: {required},
      chuTri: {required}
    },
    modelCongViec:{
      tuNgay: {required},
    }
  },
  created() {
    // this.fnGetList();
    let lichCongTacId = this.$route.params.id;
    if(lichCongTacId == null){
      this.$router.push('/lich-cong-tac-ca-nhan');
    }
    this.handleDetail(this.$route.params.id)
    this.getUser();
  },
  watch: {
    model: {
      deep: true,
      handler(val) {
        // addCoQuanToModel()
        // this.saveValueToLocalStorage()
      }
    },
  },
  methods: {
    async fnGetList() {
      await this.onPageChange();
    },
    async getUser() {
      try {
        await this.$store.dispatch("userStore/getAll").then(resp => {
          if (resp.resultCode == "SUCCESS") {
            let items = resp.data
            this.loading = false
            this.optionsUser = items;
          }
          return [];
        });
      } finally {
        this.loading = false
      }
    },
    async onPageChange() {
      this.$refs.tblList?.refresh()
    },
    async handleUpdate(value) {
      await this.$store.dispatch("lichCongTacStore/getByIdCongViec", value).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.modelCongViec = congViecModel.fromJson(res.data);

          this.showCongViecModel = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
        }
      });
    },
    async handleDetail(id) {
      await this.$store.dispatch("lichCongTacStore/getById", id).then((res) => {
        if (res.resultCode === 'SUCCESS') {
          this.model = lichCongTacModel.fromJson(res.data);
          this.modelCongViec.tuNgay = this.model.ngayXepLich;
          this.showDetail = true;
        } else {
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          this.$router.push("/lich-cong-tac-ca-nhan")
        }
      });
    },
    async handleDelete() {
      if (this.modelCongViec.id != 0 && this.modelCongViec.id != null && this.modelCongViec.id) {
        await this.$store.dispatch("lichCongTacStore/deleteCongViec", this.modelCongViec).then((res) => {
          if (res.resultCode === 'SUCCESS') {
            this.modelCongViec = congViecModel.baseJson();
            this.handleDetail(this.$route.params.id)
            this.showDeleteModal = false;
          }
          this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res));
          // });
        });
      }
    },
    handleShowDeleteModal(value) {
      this.modelCongViec = value;
      this.showDeleteModal = true;
    },
    async handleSubmit(e) {
      e.preventDefault();
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.modelCongViec.$invalid) {
        return;
      } else {
        let loader = this.$loading.show({
          container: this.$refs.formContainer,
        });
        if (
            this.modelCongViec.id != 0 &&
            this.modelCongViec.id != null &&
            this.modelCongViec.id
        ) {
          // Update model
          await this.$store.dispatch("lichCongTacStore/updateCongViec", this.modelCongViec).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.modelCongViec = congViecModel.baseJson();
              this.handleDetail(this.$route.params.id)
              this.showCongViecModel = false;
            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        } else {
          // Create model
          await this.$store.dispatch("lichCongTacStore/createCongViec", this.modelCongViec).then((res) => {
            if (res.resultCode === 'SUCCESS') {
              this.modelCongViec = congViecModel.baseJson();
              this.handleDetail(this.$route.params.id)
              this.showCongViecModel = false;

            }
            this.$store.dispatch("snackBarStore/addNotify", notifyModel.addMessage(res))
          });
        }
        loader.hide();
      }
      this.submitted = false;
    },
    myProvider(ctx) {
      const params = {
        start: ctx.currentPage,
        limit: ctx.perPage,
        content: this.filter,
        sortBy: ctx.sortBy,
        sortDesc: ctx.sortDesc,
      }
      this.loading = true
      try {
        let promise = this.$store.dispatch("lichCongTacStore/getPagingParamsCaNhan", params)
        return promise.then(resp => {
          if (resp.resultCode == CONSTANTS.SUCCESS) {
            let data = resp.data;
            this.totalRows = data.totalRows
            let items = data.data
            this.numberOfElement = items.length
            this.loading = false
            return items || []
          } else {
            return [];
          }
        })
      } finally {
        this.loading = false
      }
    },
    handleShowCongViecModal(data) {
      this.modelCongViec.lichCongTacId = this.$route.params.id;
      this.showCongViecModel = true;
    },
    removeThisFile(file, error, xhr) {
      let fileCongViec = JSON.parse(file.xhr.response);
      if (fileCongViec.data && fileCongViec.data.id) {
        let idFile = fileCongViec.data.id;
        let resultData = this.modelCongViec.uploadFiles.filter(x => {
          return x.fileId != idFile;
        })
        this.modelCongViec.uploadFiles = resultData;
      }
    },
    addThisFile(file, response) {
      if (this.modelCongViec) {
        if (this.modelCongViec.uploadFiles == null || this.modelCongViec.uploadFiles.length <= 0) {
          this.modelCongViec.uploadFiles = [];
        }
        let fileSuccess = response.data;
        this.modelCongViec.uploadFiles.push({fileId: fileSuccess.id, fileName: fileSuccess.fileName, ext: fileSuccess.ext})
      }
    },
  }
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <div class="search-box me-2 mb-2 d-inline-block">
                  <div class="position-relative" style="display: flex; flex-direction: column;">
                  <h5>{{model.ngayXepLich}}</h5>
                    <h6>Người chủ trì: </h6>
                    <span v-for="(value, index) in model.chuTri" :key="index">
                      {{index+1}}.{{value.fullName}} - {{value.donVi.ten}}
                    </span>
                  </div>
                </div>
              </div>
              <div class="col-sm-8">
                <div class="text-sm-end">
                  <b-button
                      variant="primary"
                      type="button"
                      class="btn w-md btn-primary"
                        @click="handleShowCongViecModal"
                      size="sm"
                  >
                    <i class="mdi mdi-plus me-1"></i> Thêm mới
                  </b-button>
                  <!--                  Modal create -->
                  <b-modal
                      v-model="showCongViecModel"
                      title="Thông tin công việc"
                      title-class="text-black font-18"
                      body-class="p-3"
                      header-class="cs-modal-header"
                      hide-footer
                      centered
                      no-close-on-backdrop
                      size="xl"
                  >
                    <template #modal-header="{ }">
                      <!-- Emulate built in modal header close button action -->
                      <h5> Thông tin công việc</h5>
                      <div class="text-end">
                        <b-button variant="light" class="w-md" size="sm" @click="showCongViecModel = false">
                          Đóng
                        </b-button>
                        <b-button @click="handleSubmit" variant="primary" size="sm" class="ms-1 w-md">
                          Lưu
                        </b-button>
                      </div>
                    </template>
                    <form @submit.prevent="handleSubmit"
                          ref="formContainer">
                      <div class="row">
                        <div class="col-lg-3 col-md-6">
                          <div class="mb-3">
                            <label class="text-left">Ngày bắt đầu</label>
                            <span style="color: red">&nbsp;*</span>
                            <input type="hidden" v-model="modelCongViec.id"/>
                            <date-picker v-model="modelCongViec.tuNgay"
                                         format="DD/MM/YYYY"
                                         value-type="format"
                                         readonly=""
                            >
                              <div slot="input">
                                <input v-model="modelCongViec.tuNgay"
                                       v-mask="'##/##/####'" type="text" class="form-control"
                                       placeholder="Nhập ngày bắt đầu"
                                readonly
                                />
                              </div>
                            </date-picker>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <div class="mb-3">
                            <label class="text-left">Ngày kết thúc</label>
                            <date-picker v-model="modelCongViec.denNgay"
                                         format="DD/MM/YYYY"
                                         value-type="format"
                            >
                              <div slot="input">
                                <input v-model="modelCongViec.denNgay"
                                       v-mask="'##/##/####'" type="text" class="form-control"
                                       placeholder="Nhập ngày kết thúc"/>
                              </div>
                            </date-picker>
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <div class="mb-3">
                            <label class="text-left">Thời gian</label>
                            <input v-model.trim="modelCongViec.thoiGian" v-mask="'##:##'" type="text" class="form-control" placeholder="##:##" />
                          </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                          <div class="mb-3">
                            <label class="text-left">Màu sắc</label>
                            <input
                                type="color"
                                class="form-control-color mw-100 form-control"
                                id="example-color-input"
                                v-model="modelCongViec.mauSac"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="mb-2">
                            <label class="form-label" for="validationCustom01">Nội dung</label>
                            <span style="color: red">&nbsp;*</span>
                            <ckeditor-nuxt v-model="modelCongViec.noiDung" :config="editorConfig"  />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="mb-2">
                            <label class="form-label" for="validationCustom01">Địa điểm</label>
                            <span style="color: red">&nbsp;*</span>
                            <ckeditor-nuxt v-model="modelCongViec.diaDiem" :config="editorConfig"  />
                          </div>
                        </div>

                        <div class="col-12">
                          <div class="mb-3">
                            <label class="text-left">Thành phần tham dự</label>
                            <multiselect
                                :multiple="true"
                                v-model="modelCongViec.thanhPhanThamDu"
                                :options="optionsUser"
                                track-by="id"
                                label="fullName"
                                placeholder="Chọn người tham dự"
                                deselect-label="Nhấn để xoá"
                                selectLabel="Nhấn enter để chọn"
                                selectedLabel="Đã chọn"
                            ></multiselect>
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                          <div class="mb-2">
                            <label class="form-label" for="validationCustom01">Thành phần khác</label>

                            <ckeditor-nuxt v-model="modelCongViec.thanhPhan" :config="editorConfig"  />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12">
                        <div class="mb-2">
                          <label class="form-label" for="validationCustom01">Ghi chú</label>

                          <ckeditor-nuxt v-model="modelCongViec.ghiChu" :config="editorConfig"  />
                        </div>
                      </div>
                      <div class="col-lg-12">
                              <label for="">Tệp tin đính kèm</label>
                              <div style="color: red">Lưu ý: Tệp tin pdf hoặc word</div>
                              <vue-dropzone id="dropzone" ref="myVueDropzone" :use-custom-slot="true"
                                            :options="dropzoneOptions" v-on:vdropzone-removed-file="removeThisFile"
                                            v-on:vdropzone-success="addThisFile">
                                <div class="">
                                  <i class="display-1 text-muted bx bxs-cloud-upload" style="font-size: 70px"></i>
                                  <p class="font-size-18">
                                    Kéo thả tệp tin hoặc bấm vào để tải tệp tin
                                  </p>
                                </div>
                              </vue-dropzone>
                            </div>
                      </div>
                    </form>
                  </b-modal>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <div class="table-responsive-sm">
                  <b-table
                      class="datatables"
                      :items="model.congViecs"
                      :fields="fields"
                      striped
                      bordered
                      responsive="sm"
                      :per-page="perPage"
                      :current-page="currentPage"
                      :sort-by.sync="sortBy"
                      :sort-desc.sync="sortDesc"
                      :filter="filter"
                      :filter-included-fields="filterOn"
                      ref="tblList"
                      primary-key="id"
                      :busy.sync="isBusy"
                  >
                    <template v-slot:cell(STT)="data">
                      {{ data.index + ((currentPage - 1) * perPage) + 1 }}
                    </template>
                    <template v-slot:cell(tuNgay)="data">
                      <div>{{data.item.tuNgay}}</div>
                      <div v-if="data.item.denNgay">
                        -{{data.item.denNgay}}
                      </div>
                      <div v-else>
                        -...
                      </div>
                    </template>
                    <template v-slot:cell(noiDung)="data">
                      <div v-if="data.item.noiDung" :inner-html.prop="data.item.noiDung">
                      </div>
                    </template>
                    <template v-slot:cell(diaDiem)="data">
                      <div v-if="data.item.diaDiem" :inner-html.prop="data.item.diaDiem">
                      </div>
                    </template>
                    <template v-slot:cell(ghiChu)="data">
                      <div v-if="data.item.ghiChu" :inner-html.prop="data.item.ghiChu">
                      </div>
                    </template>
                    <template v-slot:cell(thanhPhan)="data">
                      <div v-if="data.item.thanhPhanThamDu && data.item.thanhPhanThamDu.length">
                        <div class="title-capso">Thành phần tham dự: </div>
                            <div class="badge font-size-small min-width-30 p-2 btn-xs font-weight-semibold bg-success" v-for="(value, index) in data.item.thanhPhanThamDu" :key="index">
                              {{value.fullName}}-<span style="color: #560404">{{value.donVi.ten}}</span>
                            </div>
                      </div>
                      <div  v-if="data.item.thanhPhan">
                        <div class="title-capso">Thành phần khác: </div>
                        <div :inner-html.prop="data.item.thanhPhan">
                        </div>
                      </div>
                    </template>
                    <template v-slot:cell(process)="data">
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-edit btn-sm"
                          data-toggle="tooltip" data-placement="bottom" title="Cập nhật"
                          v-on:click="handleUpdate(data.item)">
                        <i class="fas fa-pencil-alt"></i>
                      </button>
                      <button
                          type="button"
                          size="sm"
                          class="btn btn-delete btn-sm"
                          data-toggle="tooltip" data-placement="bottom" title="Xóa"
                          v-on:click="handleShowDeleteModal(data.item)">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </template>
                    <template v-slot:cell(ten)="data">&nbsp;&nbsp;
                      {{ data.item.ten }}
                    </template>
                  </b-table>
                  <template v-if="isBusy">
                    <div align="center">Đang tải dữ liệu</div>
                  </template>
                  <template v-if="totalRows <= 0 && !isBusy">
                    <div align="center">Không có dữ liệu</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <b-modal
            v-model="showDeleteModal"
            centered
            title="Xóa dữ liệu"
            title-class="font-18"
            no-close-on-backdrop
        >
          <p>
            Dữ liệu xóa sẽ không được phục hồi!
          </p>
          <template #modal-footer>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      class="btn btn-outline-info w-md"
                      v-on:click="showDeleteModal = false">
              Đóng
            </b-button>
            <b-button v-b-modal.modal-close_visit
                      size="sm"
                      variant="danger"
                      type="button"
                      class="w-md"
                      v-on:click="handleDelete">
              Xóa
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
  </Layout>
</template>
<style>
.td-stt {
  text-align: center;
  width: 50px;
}

.td-xuly {
  text-align: center;
  width: 130px;
}

.hidden-sortable:after, .hidden-sortable:before {
  display: none !important;
}

.ck-editor__editable{
  min-height: 100px !important;
}
.title-capso{
  font-weight: 500; color: #00568C; margin-right: 10px;
}

@media only screen and (max-width: 768px){

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
    padding: 5px 0px !important;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr { border: 1px solid #f5f5f5;
    margin-bottom: 5px;
  }

  .table-bordered > :not(caption) > * {
    border-width: 0.5px;
    border-radius: 5px;
  }

  .table-bordered{
    border: none;
  }

  .table-bordered th:first-child, .table-bordered td:first-child{
    border-top: none;
  }

  .table-bordered th, .table-bordered td{
    border: none;
    border-top: 1px solid #f5f5f5;
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    min-height: 30px !important;
    padding-left: 20% !important;
    padding: 5px 0px;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    /* Top/left values mimic padding */
    top: 5px;
    left: 6px;
    padding-right: 10px;
    white-space: nowrap;
  }

  .btn-process {
    padding: 0px !important;
  }

  .btn-process .btn {
    background-color: rgb(0 89 144 / 0.1);
    width: 20%;
    margin: 5px;
  }

  /*
  Label the data
  */
  td:nth-of-type(1):before { content: "STT"; font-weight: bold; }
  td:nth-of-type(2):before { content: "Ngày"; font-weight: bold; }
  td:nth-of-type(3):before { content: "Thời gian"; font-weight: bold; }
  td:nth-of-type(4):before { content: "Nội dung"; font-weight: bold; }
  td:nth-of-type(5):before { content: "Địa điểm"; font-weight: bold; }
  td:nth-of-type(6):before { content: "Thành phần"; font-weight: bold; }
  td:nth-of-type(7):before { content: "Ghi chú"; font-weight: bold; }
  td:nth-of-type(8):before { content: ""; font-weight: bold; }
}

@media only screen and (max-width: 425px){
  td{
    padding-left: 25% !important;
  }
}

@media only screen and (max-width: 375px){
  td{
    padding-left: 30% !important;
  }
}

@media only screen and (max-width: 320px){
  td{
    padding-left: 35% !important;
  }
}
.cs-modal-header{
  background-color: #f2f6fc;
  border: none;
}
</style>
